<template>
  <div>
    <template v-if="readonly">
      <v-subheader class="label" v-if="label.length>0">{{label}}</v-subheader>
      <v-layout align-center justify-center row fill-height>
        <v-flex md1 v-if="isNegative">-</v-flex>
        <v-flex md2>
          <p class="hour">{{hour}}</p>
        </v-flex>
        <v-flex md1>時</v-flex>
        <v-flex md2 offset-md1>
          <p class="min">{{min}}</p>
        </v-flex>
        <v-flex md1>分</v-flex>
      </v-layout>
    </template>
    <template v-else>
      <v-subheader class="label" v-if="label.length>0">{{label}}</v-subheader>
      <v-layout row wrap>
        <v-flex md1 v-if="isNegative">-</v-flex>
        <v-flex md3>
          <input
            v-model="hour"
            label="時"
            :readonly="readonly"
            min="0"
            type="tel"
            suffix="時"
          />
        </v-flex>
        <v-flex md1>時</v-flex>
        <v-flex md3 offset-md1>
          <input
            v-model="min"
            label="分"
            :readonly="readonly"
            max="59"
            min="0"
            type="tel"
            suffix="分"
          />
        </v-flex>
        <v-flex md1>分</v-flex>
      </v-layout>
    </template>
  </div>
</template>
<script>
export default {
  data: () => ({
    minNoDataText: "",
    isNegative: false
  }),
  props: {
    value: {
      default: 0,
      type: Number
    },
    readonly: {
      default: false,
      type: Boolean
    },
    isBy10Minutes: {
      default: false,
      type: Boolean
    },
    label: {
      default: "",
      type: String
    }
  },
  computed: {
    hour: {
      get() {
        this.isNegative = this.value < 0;
        return Math.floor(Math.abs(this.value) / 3600);
      },
      set(hour) {
        var numHour = hour.length == 0 ? 0 : parseInt(this.zenkakuTohankaku(hour))
        this.$emit("input", numHour * 3600 + this.min * 60);
      }
    },
    min: {
      get() {
        return Math.floor((Math.abs(this.value) % 3600) / 60);
      },
      set(min) {
        var numMin = min.length == 0 ? 0 : parseInt(this.zenkakuTohankaku(min))
        this.$emit("input", this.hour * 3600 + numMin * 60);
      }
    }
  },
  methods:{
    zenkakuTohankaku(str){
    return str.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(s) {
        return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
    });

    }
  },
  created() {
    if (this.isBy10Minutes) {
      this.minutes = [0, 10, 20, 30, 40, 50];
      this.minNoDataText =
        "0から50までの半角数字を10分単位で入力してください。";
    } else {
      this.minutes = [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        28,
        29,
        30,
        31,
        32,
        33,
        34,
        35,
        36,
        37,
        38,
        39,
        40,
        41,
        42,
        43,
        44,
        45,
        46,
        47,
        48,
        49,
        50,
        51,
        52,
        53,
        54,
        55,
        56,
        57,
        58,
        59
      ];
      this.minNoDataText =
        "0から50までの半角数字を10分単位で入力してください。";
    }
  }
};
</script>
<style lang="scss" scoped>
select {
  border-radius: 0;
  border: solid 1px gray;
  width: 100%;
  -webkit-appearance: menulist;
}
input {
  border-radius: 0;
  border-bottom: solid 1px gray;
  width: 100%;
}
.label {
  padding: 0;
  height: 30px;
  font-size: 12px;
}
.hour,
.min {
  margin: 0;
}
</style>

